import * as React from "react";

const ASANotVerifiedIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 186.77 186.77" {...props}>
		<path d="M95.69 88.39c22.32 0 44.63.03 66.95-.03 4.03-.01 6.81 1.71 7.93 5.48.99 3.33-.78 5.75-3.47 7.59-1.48 1.01-3.16.93-4.82.93-44.63 0-89.26.02-133.89-.01-5.2 0-8.5-2.95-8.39-7.15.11-4.14 3.42-6.8 8.75-6.8 22.32-.03 44.63-.01 66.95-.01Z" />
	</svg>
);

export default ASANotVerifiedIcon;
